'use client';

import useModalStore from '@module/stores/useModalStore';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import useGetLoginInfoQuery from '../auth/useGetLoginInfoQuery';

function VIPSignatureAlert() {
  const router = useRouter();
  const { pushModal, popModal } = useModalStore();
  const { isLogin, userInfo } = useGetLoginInfoQuery();

  const popup = userInfo?.vipSignatureInfo?.popup;
  const nick = userInfo?.nick;
  const addLimit = userInfo?.vipSignatureInfo?.addLimit ?? 0;

  useEffect(() => {
    if (!isLogin) return;
    if (window.location.pathname.includes('/setting/broadcast')) return;
    if (popup !== 'Y') return;
    pushModal({
      type: 'CONFIRM_CANCEL_MODAL',
      options: {
        description:
          addLimit > 1
            ? `${nick}님! VIP 시그니처 이모티콘을 추가로 사용하실 수 있습니다.\n지금 바로 등록해 보세요.`
            : `${nick}님! 이제 VIP 시그니처 이모티콘을 사용하실 수 있습니다.\n지금 바로 등록해 보세요.`,
        onClick: () => {
          router.push('/my/signatureUser');
          popModal();
        },
      },
    });
  }, [isLogin, popup, nick, addLimit]);
  return null;
}

export default VIPSignatureAlert;
